// side effect: fetch new price calculation when decisions are made
import {fetchPrice} from '../slices/priceSlice';

export const priceMiddleware = store => next => action => {
    const result = next(action);

    if (action.type === 'decisions/decision/fulfilled' || action.type === 'decisions/decisionsLoading/fulfilled') {
        if (store.getState().session.sessionId !== null) {
            // after decision(s), get the new prices
            store.dispatch(fetchPrice({
                features: store.getState().decisions.data.decisions
                    .filter(dec => dec.featureValues.find(fv => fv.state === 'Included'))
                    .map(dec => ({
                            featureId: dec.variableId,
                            valueId: dec.featureValues.find(f => f.state === 'Included').featureValueId
                        })
                    )
            }));
        }
    }
    return result;
};
